import React from 'react';
import { useSessionStorage } from 'react-use';
import { TableViewSettings } from './useUserListTableData';
import { VISIBLE_ROLES } from '../roles';

export const STORAGE_KEY = 'userListFilters';

export const useFilters = () => {
    const [filterSnapshot, updateSessionStorage] = useSessionStorage<{
        nameFilter?: string;
        roleFilter?: (typeof VISIBLE_ROLES)[number];
        idpIdFilter?: string;
        sort?: TableViewSettings['sort'];
        page?: number;
    }>(STORAGE_KEY, {}, false);

    const [nameFilter, setNameFilter] = React.useState(
        filterSnapshot.nameFilter || '',
    );
    const [roleFilter, setRoleFilter] = React.useState<
        undefined | (typeof VISIBLE_ROLES)[number]
    >(filterSnapshot.roleFilter);

    const [idpIdFilter, setIdpIdFilter] = React.useState(
        filterSnapshot.idpIdFilter,
    );

    const [sort, setSort] = React.useState<TableViewSettings['sort']>(
        filterSnapshot.sort,
    );

    const [page, setPage] = React.useState(filterSnapshot.page || 1);

    const returnVal = React.useMemo(
        () => ({
            nameFilter,
            setNameFilter,
            roleFilter,
            setRoleFilter,
            idpIdFilter,
            setIdpIdFilter,
            sort,
            setSort,
            page,
            setPage,
        }),
        [nameFilter, roleFilter, idpIdFilter, sort, page],
    );

    const prevReturnVal = React.useRef(returnVal);

    React.useEffect(() => {
        if (prevReturnVal.current !== returnVal) {
            updateSessionStorage({
                nameFilter,
                roleFilter,
                idpIdFilter,
                sort,
                page,
            });
            prevReturnVal.current = returnVal;
        }
    }, [
        nameFilter,
        roleFilter,
        idpIdFilter,
        sort,
        updateSessionStorage,
        page,
        returnVal,
    ]);

    return returnVal;
};
